(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBnzFp(root) {
      if (!root || root.bnzFpSwiper) return;
      var el = root.querySelector('[data-bnz-fp-swiper]');
      if (!el || typeof Swiper === 'undefined') return;

      var slides = el.querySelectorAll('.swiper-slide');
      var total = slides.length;
      var fill = root.querySelector('[data-bnz-fp-fill]');
      var moto = root.querySelector('[data-bnz-fp-moto]');

      function updateProgress(sw) {
        var pct = total ? ((sw.activeIndex + 1) / total) * 100 : 0;
        if (fill) fill.style.width = pct + '%';
        if (moto) moto.style.left = pct + '%';
        // Seul le produit central est atteignable au clavier
        slides.forEach(function (slide, i) {
          var isActive = i === sw.activeIndex;
          slide.querySelectorAll('a').forEach(function (a) { a.tabIndex = isActive ? 0 : -1; });
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }

      var swiper = new Swiper(el, {
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: Math.min(1, total - 1),
        spaceBetween: 0,
        rewind: true,
        grabCursor: true,
        speed: 550,
        threshold: 6,
        preventClicks: true,
        preventClicksPropagation: true,
        touchStartPreventDefault: false,
        mousewheel: { forceToAxis: true, thresholdDelta: 2 },
        keyboard: { enabled: true, onlyInViewport: true },
        on: {
          init: updateProgress,
          slideChange: updateProgress
        }
      });
      root.bnzFpSwiper = swiper;

      // Clic sur un produit flouté : il passe au centre au lieu d'ouvrir sa fiche.
      el.addEventListener('click', function (e) {
        var slide = e.target.closest('.swiper-slide');
        if (!slide) return;
        var index = Array.prototype.indexOf.call(slides, slide);
        if (index !== swiper.activeIndex) {
          e.preventDefault();
          e.stopPropagation();
          swiper.slideTo(index);
        }
      }, true);

      var prev = root.querySelector('[data-bnz-fp-prev]');
      var next = root.querySelector('[data-bnz-fp-next]');
      if (prev) prev.addEventListener('click', function () { swiper.slidePrev(); });
      if (next) next.addEventListener('click', function () { swiper.slideNext(); });

      // Les images chargées après coup changent la hauteur : on recalcule.
      window.addEventListener('load', function () { swiper.update(); }, { once: true });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-bnz-fp]').forEach(initBnzFp);
    }

    // Ce script peut s'exécuter avant swiper-bundle.min.js (chargé en defer par layout/theme.liquid) :
    // on attend que la page soit prête, Swiper est alors disponible.
    if (document.readyState === 'complete') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
      window.addEventListener('load', function () { initAll(); });
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-bnz-fp]');
      if (root && root.bnzFpSwiper) {
        root.bnzFpSwiper.destroy(true, true);
        root.bnzFpSwiper = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boutiques"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBnzShops(root) {
      if (!root || root.bnzShopsReady) return;
      root.bnzShopsReady = true;

      var tabs = root.querySelectorAll('[data-bnz-shops-tab]');
      var panels = root.querySelectorAll('[data-bnz-shops-panel]');
      var medias = root.querySelectorAll('[data-bnz-shops-media]');

      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });
        panels.forEach(function (panel, i) {
          panel.hidden = i !== index;
        });
        medias.forEach(function (media, i) {
          var on = i === index;
          media.classList.toggle('is-active', on);
          media.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (media.tagName === 'A') media.tabIndex = on ? 0 : -1;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); select((i + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
        });
      });

      root.bnzShopsSelect = select;
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-bnz-shops]').forEach(initBnzShops);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Éditeur de thème : recharge de la section et sélection d'un bloc
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-bnz-shops]');
      if (!root || !root.bnzShopsSelect) return;
      var index = Number(e.target.getAttribute('data-bnz-shops-tab'));
      if (!isNaN(index)) root.bnzShopsSelect(index);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
